<template>
    <div class="lot__info">
      <!--  <div class="lot__info-item" v-if="!lot.deleted_at">
            <span class="lot__info-name">Текущая цена</span>
            <span class="lot__price">{{ lot.last_price ? Number(lot.last_price).toLocaleString('ru') : Number(lot.original_price).toLocaleString('ru') }} ₽</span>
        </div>-->
        <div class="lot__info-item" v-if="lot.deleted_at && lot.last_price > 0">
            <span class="lot__info-name">Выигрышная ставка</span>
            <span class="lot__price">{{ Number(lot.last_price).toLocaleString('ru') }} ₽</span>
        </div>
        <div class="lot__info-item" v-if="!lot.deleted_at">
            <span class="lot__info-name" v-if="checkBeforeNowDate(lot.start_auction)">Идут торги</span>
            <span class="lot__info-name" v-else>Ожидает торгов</span>
           <!-- <span class="lot__info-name">До конца торгов</span>
            <countdown class="lot__time" :time="lot.countdown" :transform="transform">
                <template slot-scope="props">
                    <template v-if="props.days !== '00'">
                        <span class="auction__time-item">{{ props.days }}</span>д
                    </template>
                    <span class="lot__time-item">{{ props.hours }}</span> :
                    <span class="lot__time-item">{{ props.minutes }}</span>
                    <template v-if="props.days === '00'">
                        : <span class="auction__time-item">{{ props.seconds }}</span>
                    </template>
                </template>
            </countdown>-->
        </div>
        <div class="lot__info-item" v-else>
            <span class="lot__info-name">Торги завершены</span>
        </div>
        <div class="lot__info-item">
            <span class="lot__info-name">Всего ставок</span>
            <span class="lot__bets">{{ lot.bids.length }}</span>
        </div>
        <div class="lot__bet" v-if="lot.bids.length && lot.bids[0].city">
            Текущая ставка из
            <span class="lot__bet-city">{{ lot.bids[0].city.title}}</span>
        </div>
        <div class="lot__app">
            <svg class="lot__app-icon">
                <use xlink:href="/assets/front/img/sprite.svg#icon-phone"></use>
            </svg>
            <div>
                <div class="lot__app-description">
                    Чтобы принять участие в аукционе скачате приложение на Ваше мобильное устройство
                </div>
                <button class="btn btn--main btn--middle">Скачать</button>
            </div>
        </div>
        <div class="lot__links">
            <a href="https://antiqbay.com/storage/bidding-rules/rules.pdf" target="_blank" class="lot__link">
                <svg class="lot__link-icon">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-info"></use>
                </svg>
                Правила торгов
            </a>
            <a href="#" v-on:click.stop="visible = true" class="lot__link">
                <svg class="lot__link-icon">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-share"></use>
                </svg>
                Поделиться лотом
            </a>
        </div>
        <el-dialog
                class="popup"
                :width="windowWidth > 1200 ? '600px' : '90%'"
                :append-to-body="true"
                :show-close="false"
                :visible.sync="visible">
            <button class="btn popup__close" @click.prevent="visible = false">
                <i class="el-icon-close"></i>
            </button>
            <social-popup></social-popup>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {store} from "../../../store/lot";
    import style from "../../../mixins/style";
    import SocialPopup from "./socialPopup";

    export default {
        name: "DesktopLot",
        components: {SocialPopup},
        store,
        mixins: [style],
        data: () => ({
            visible: false,
        }),
        computed: {
            ...mapState([
                'lot',
            ]),
        },
    }
</script>